import { TransportType } from '../types';

const predicate = (transportTypes: TransportType[]) => {
  const selectedTransportTypes =
    transportTypes &&
    new Set(
      transportTypes.filter(({ checked }) => checked).map(({ id }) => id)
    );
  return ({ legs }) => {
    if (!selectedTransportTypes) {
      return true;
    }
    return legs.every(({ segments }) => {
      const { transportTypes } = segments[0];
      return transportTypes.every((transportType) =>
        selectedTransportTypes.has(transportType)
      );
    });
  };
};

export default predicate;
